import React, {FC, ReactNode} from 'react';

import * as Sentry from '@sentry/react';

const onErrorHandler = () => {
    const feedback = Sentry.getFeedback();
    feedback?.createForm().then(form => {
        form.appendToDom();
        form.open();
    });
};

/**
 * Wrapper for sentry error boundary.
 */
export const ErrorBoundary: FC<{children: ReactNode; fallback?: Sentry.FallbackRender}> = ({
    children,
    fallback,
}) => (
    <Sentry.ErrorBoundary fallback={fallback} onError={onErrorHandler}>
        {children}
    </Sentry.ErrorBoundary>
);
